import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/verdetalle.png'
import _imports_1 from '@/assets/icons/equipos.png'


const _withScopeId = n => (_pushScopeId("data-v-d83203c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Detalle",
  width: "50",
  height: "50"
}, null, -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Icono personalizado",
  width: "40",
  height: "40"
}, null, -1))
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { colspan: "3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle-1 font-weight-bold" }, "Participantes", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Detalle",
  width: "30",
  height: "30"
}, null, -1))

import { TorneoEquipoGestionInfoDTO } from "@/interfaces/Inscripcion";
import { ListaJugador } from "@/interfaces/Lista";
import { Torneo, TorneoGestionInfoDTO } from "@/interfaces/Torneo";
import { getListaById } from "@/services/ListasService";
import {
  getInfoTorneoCreado,
  getInfoTorneoEquipoCreado,
} from "@/services/TorneosService";
import { ref, watch } from "vue";
import ModalVerLista from "../Inscripcion/ModalVerLista.vue";
import { useRouter } from "vue-router";
import { ArmyDTO } from "@/interfaces/Army";
import { appsettings } from "@/settings/appsettings";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabMostrarListas',
  props: {
    torneo: {}
  },
  setup(__props: any) {

const props = __props;

const torneoIndividual = ref<TorneoGestionInfoDTO>();
const torneoEquipos = ref<TorneoEquipoGestionInfoDTO>();

const search = ref<string>("");
const isLoading = ref<boolean>(true);
const headers = [{ title: "Nick", key: "nick" }];
const headersEquipos = [{ title: "Nombre del equipo", key: "nombreEquipo" }];
const expanded = ref<string[]>([]);
const listaJugador = ref<ListaJugador>();
const showVerListaModal = ref<boolean>(false);
const router = useRouter();
const listadoEjercitos = ref<ArmyDTO[]>(appsettings.armies);

watch(
  () => props.torneo,
  async (nuevoTorneo) => {
    if (!nuevoTorneo) return;

    isLoading.value = true;

    try {
      if (nuevoTorneo.tipoTorneo === "Individual") {
        const response = await getInfoTorneoCreado(nuevoTorneo.idTorneo);
        torneoIndividual.value = response.data;
      } else {
        const response = await getInfoTorneoEquipoCreado(nuevoTorneo.idTorneo);
        torneoEquipos.value = response.data;
      }
    } catch (error) {
      console.error("Error al obtener participantes/equipos:", error);
    } finally {
      isLoading.value = false;
    }
  },
  { immediate: true }
);

function toggleExpand(nombreEquipo: string) {
  if (expanded.value.includes(nombreEquipo)) {
    expanded.value = expanded.value.filter((e) => e !== nombreEquipo);
  } else {
    expanded.value.push(nombreEquipo);
  }
}

const verLista = async (idLista: number, nombre: string, ejercito: string) => {
  const responseLista = await getListaById(idLista);
  const listaJugadorDTO: ListaJugador = {
    listaData: responseLista.data.listaData,
    nick: nombre,
    nombreEjercito: ejercito,
  };
  listaJugador.value = listaJugadorDTO;
  showVerListaModal.value = true;
};

const goToUserDetail = (idUsuario: number) => {
  router.push({ name: "detalle-jugador", params: { idUsuario: idUsuario } });
};

function getColorPorEjercito(nombreEjercito: string): string {
  const ejercito = listadoEjercitos.value.find(
    (e) => e.name === nombreEjercito
  );
  if (!ejercito) return "grey";
  return ejercito.band === "good" ? "green" : "purple";
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, { flat: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
          default: _withCtx(() => [
            (_ctx.torneo?.tipoTorneo == 'Individual')
              ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                  _createVNode(_component_v_icon, { left: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-account-group")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" Participantes ")
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_2, [
                  _createVNode(_component_v_icon, { left: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-account-group")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" Equipos")
                ])),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_text_field, {
              modelValue: search.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              label: "Buscar",
              "prepend-inner-icon": "mdi-magnify",
              variant: "tonal",
              dense: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_divider),
        (_ctx.torneo?.tipoTorneo == 'Individual')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_data_table, {
                search: search.value,
                "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
                items: torneoIndividual.value?.inscripciones,
                loading: isLoading.value,
                headers: headers
              }, {
                item: _withCtx(({ item }) => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_chip, {
                        onClick: ($event: any) => (goToUserDetail(item.idUsuario)),
                        color: "orange",
                        dark: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.nick), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      (item.idLista != 0)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            icon: "",
                            onClick: _withModifiers(($event: any) => (verLista(item.idLista, item.nick, item.ejercito)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (item.idLista)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 1,
                            color: "orange",
                            dark: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.ejercito), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["search", "items", "loading"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_v_data_table, {
                search: search.value,
                "onUpdate:search": _cache[2] || (_cache[2] = ($event: any) => ((search).value = $event)),
                items: torneoEquipos.value?.equipos,
                loading: isLoading.value,
                headers: headersEquipos,
                class: "styled-table",
                "item-key": "nombreEquipo"
              }, {
                item: _withCtx(({ item }) => [
                  _createElementVNode("tr", {
                    onClick: ($event: any) => (toggleExpand(item.nombreEquipo)),
                    class: "clickable-row"
                  }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_avatar, {
                        color: "indigo",
                        size: "40"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }),
                      _createTextVNode("   "),
                      _createVNode(_component_v_chip, {
                        color: "orange darken-2",
                        "text-color": "white",
                        class: "font-weight-bold"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.nombreEquipo), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("td", _hoisted_8, [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(expanded.value.includes(item.nombreEquipo)
                    ? "mdi-chevron-up"
                    : "mdi-chevron-down"), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ], 8, _hoisted_6),
                  (expanded.value.includes(item.nombreEquipo))
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                        _createElementVNode("td", _hoisted_10, [
                          _createVNode(_component_v_card, { class: "pa-3 mx-4 expanded-card" }, {
                            default: _withCtx(() => [
                              _hoisted_11,
                              _createVNode(_component_v_list, { dense: "" }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.inscripciones, (participante) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: participante.idUsuario
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_chip, {
                                              onClick: ($event: any) => (goToUserDetail(participante.idUsuario)),
                                              color: 
                          item.idCapitan === participante.idUsuario
                            ? 'teal'
                            : 'orange'
                        ,
                                              dark: ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(participante.nick), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick", "color"]),
                                            _createElementVNode("span", {
                                              dark: "",
                                              outlined: "",
                                              small: "",
                                              class: "ml-2",
                                              style: _normalizeStyle({
                          color: getColorPorEjercito(participante.ejercito),
                        })
                                            }, _toDisplayString(participante.ejercito), 5),
                                            (participante.idLista != 0)
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 0,
                                                  icon: "",
                                                  class: "ml-2",
                                                  onClick: _withModifiers(($event: any) => (
                          verLista(
                            participante.idLista,
                            participante.nick,
                            participante.ejercito
                          )
                        ), ["stop"])
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_12
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["search", "items", "loading"])
            ]))
      ]),
      _: 1
    }),
    _createVNode(ModalVerLista, {
      isVisible: showVerListaModal.value,
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => ((showVerListaModal).value = $event)),
      listaJugador: listaJugador.value!
    }, null, 8, ["isVisible", "listaJugador"])
  ], 64))
}
}

})